import { AsyncPipe, DOCUMENT, NgClass } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { ModalOffcanvasTriggerComponent } from '@scalefast/components/modal-offcanvas-trigger';
import { CartProduct } from '@scalefast/core';
import { CartService, StaticFileHash } from '@scalefast/ecommerce-core';
import { EMPTY, Observable, Subject } from 'rxjs';
import { EventTypeEnumerate } from '../../../../../core/enumerates';
import { AnalyticsStoreService, GenericEventService } from '../../../../services/';
import { AppModalComponent } from '../../../modal/modal.component';
import { AppRemoveProductFromCartComponent } from '../../../remove-product-from-cart/remove-product-from-cart.component';
import { AppMinicartComponent } from '../minicart.component';

@Component({
  selector: 'app-minicart-offcanvas',
  templateUrl: 'minicart-offcanvas.component.html',
  styleUrls: ['./minicart-offcanvas.component.scss'],
  standalone: true,
  imports: [
    ModalOffcanvasTriggerComponent,
    NgClass,
    AppMinicartComponent,
    AppModalComponent,
    AppRemoveProductFromCartComponent,
    AsyncPipe,
    StaticFileHash,
  ],
})
export class AppMinicartOffCanvasComponent implements OnInit {
  public productToRemove$ = new Subject<CartProduct>();
  @ViewChild(AppModalComponent) cartRemovalConfirmationModal: AppModalComponent = new AppModalComponent();
  cartCount$: Observable<number> = EMPTY;
  currentCartProductToDelete?: CartProduct;
  constructor(
    private cartService: CartService,
    private genericEventService: GenericEventService,
    private analyticsStoreService: AnalyticsStoreService,
    @Inject(DOCUMENT) private _doc: Document,
  ) {}

  ngOnInit(): void {
    this.cartCount$ = this.cartService.getCount$();
    this.genericEventService.subscribe(EventTypeEnumerate.APP_MINICART_ITEM_CLICK, () => {
      this.close('offcanvas_minicart');
    });
  }

  open() {
    this._doc.body.classList.add('modal-open');
  }

  close(id: string) {
    const target = this._doc.getElementById(id);
    this.hideOffCanvas(id);
    this.hideBackdrop();
    this._doc.body.classList.remove('modal-open');
  }

  openModal(cartProduct: CartProduct): void {
    this.currentCartProductToDelete = cartProduct;
    this.cartRemovalConfirmationModal.show();
  }

  closeModal(): void {
    this.cartRemovalConfirmationModal.close();
  }

  removeCartProduct(): void {
    if (this.currentCartProductToDelete) {
      this.productToRemove$.next(this.currentCartProductToDelete);
    }
    this.closeModal();
  }

  private hideOffCanvas(id: string) {
    const target = this._doc.getElementById(id);
    if (!target) {
      return;
    }
    target.classList.remove('show');
  }

  private hideBackdrop() {
    const backdrop = this._doc.getElementById('modalBackdrop');
    if (!backdrop) {
      return;
    }
    backdrop.classList.remove('show');
  }

  gtmEvent(event: any): void {
    const category = event.target.getAttribute('data-gtmcategory');
    const action = event.target.getAttribute('data-gtmaction');
    this.analyticsStoreService.miscEvent(category, action, '');
  }
}
